<div
  leaflet
  #mapWrapper
  [style.width]="'100%'"
  [style.height]="mapHeight + 'px'"
  [ngClass]="{ 'loren-base-map-rounded': rounded }"
  (leafletMapReady)="onMapReady($event)"
  [leafletOptions]="options"
></div>
